import type { Game } from '@/mocks/games';

interface GameCardProps {
  game: Game;
}

export default function GameCard({ game }: GameCardProps) {
  return (
    <div className="group relative bg-background-900 rounded-xl overflow-hidden border border-background-700/30 hover:border-primary-500/30 transition-all duration-300 hover:translate-y-[-2px] cursor-pointer">
      <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
        <img
          src={game.imageUrl}
          alt={game.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent"></div>
        <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap">
          {game.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-semibold text-background-950 bg-primary-500 rounded-full whitespace-nowrap">
              热门
            </span>
          )}
          {game.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-semibold text-foreground-50 bg-accent-500 rounded-full whitespace-nowrap">
              新品
            </span>
          )}
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-primary-400 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-200">{game.rating}</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-user-line text-foreground-400 text-xs"></i>
              </div>
              <span className="text-xs text-foreground-400">{(game.players / 1000).toFixed(1)}k</span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors">
          {game.name}
        </h3>
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {game.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-[10px] text-foreground-500 bg-background-800/50 rounded-md whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}